import { useEffect, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Quote, Star } from 'lucide-react';
import PageHero from '@/components/shared/PageHero';
import { publicApi } from '@/lib/api';
import { motion } from 'framer-motion';
import useSEO from '@/hooks/useSEO';

export default function SuccessStoriesPage() {
    const [items, setItems] = useState([]);
    useSEO({
        title: 'Success Stories',
        description:
            'Real success stories and testimonials from beneficiaries, volunteers, and CSR partners whose lives intersect with VVVSI Trust programs across Tamil Nadu & Puducherry.',
    });
    useEffect(() => {
        publicApi.getTestimonials().then(setItems).catch(() => {});
    }, []);
    return (
        <div data-testid="success-stories-page">
            <PageHero
                eyebrow="Success Stories"
                title="Real people, real transformations."
                subtitle="Voices of beneficiaries, volunteers and CSR partners whose lives intersect with VVVSI."
            />
            <section className="section-pad">
                <div className="container-page grid md:grid-cols-2 gap-5">
                    {items.map((t, i) => (
                        <motion.div
                            key={t.id}
                            initial={{ opacity: 0, y: 10 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4, delay: i * 0.05 }}
                            viewport={{ once: true, margin: '-40px' }}
                        >
                            <Card className="h-full bg-card border-border card-lift">
                                <CardContent className="p-6 flex flex-col h-full">
                                    <Quote className="h-7 w-7 text-[hsl(var(--accent))] mb-3" />
                                    <p className="text-[15px] leading-relaxed text-foreground/85 flex-1">
                                        {t.quote}
                                    </p>
                                    <div className="mt-5 flex items-center gap-3">
                                        <Avatar className="h-11 w-11">
                                            <AvatarImage src={t.photo_url} alt={t.name} />
                                            <AvatarFallback>
                                                {t.name.slice(0, 2).toUpperCase()}
                                            </AvatarFallback>
                                        </Avatar>
                                        <div>
                                            <div className="font-semibold text-sm text-foreground">
                                                {t.name}
                                            </div>
                                            <div className="text-xs text-muted-foreground">
                                                {t.role} • {t.location}
                                            </div>
                                        </div>
                                        <div className="ml-auto flex items-center gap-0.5">
                                            {Array.from({ length: t.rating || 5 }).map((_, i) => (
                                                <Star
                                                    key={i}
                                                    className="h-3.5 w-3.5 fill-[hsl(var(--accent))] text-[hsl(var(--accent))]"
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </CardContent>
                            </Card>
                        </motion.div>
                    ))}
                </div>
            </section>
        </div>
    );
}
